import { MFOItem } from "@/types/kanban";

/**
 * Formats a number as currency (USD)
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'PHP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

/**
 * Ensures an MFO object has all required fields by providing defaults
 * for any missing required fields
 */
export const ensureMFOItem = (mfo: Partial<MFOItem>): MFOItem => {
  return {
    id: mfo.id || '', // Usually comes from the database
    code: mfo.code || '',
    title: mfo.title || '',
    departmentId: mfo.departmentId || '',
    departmentName: mfo.departmentName || '',
    status: mfo.status || 'not-started',
    budget: mfo.budget || 0,
    dueDate: mfo.dueDate || '',
    priority: mfo.priority || 'medium',
    progress: mfo.progress || 0,
    timeline: mfo.timeline || { q1: false, q2: false, q3: false, q4: false },
    successIndicators: mfo.successIndicators || [],
    collaborators: mfo.collaborators || [],
    subTasks: mfo.subTasks || [],
  };
};

/**
 * Create a partial MFO item with necessary fields for creating a new MFO
 * and assign a temporary ID if needed
 */
export const createPartialMFO = (data: Partial<MFOItem>, tempId?: string): MFOItem => {
  return {
    ...ensureMFOItem(data),
    id: tempId || data.id || `temp-${Date.now()}`
  };
};
